import { getSessionBranchId } from "./sessionBranch";

export const ERP_DASHBOARD_POOL_INVALIDATE_EVENT =
  "erp:dashboard-pool-invalidate";

export const ERP_PRODUCT_GROUP_POOL_INVALIDATE_EVENT =
  "erp:product-group-pool-invalidate";

/** Extract branch_id from socket payload (top-level or nested). */
export function socketPayloadBranchId(payload) {
  if (!payload || typeof payload !== "object") return null;
  const id =
    payload.branch_id ??
    payload.branchId ??
    payload.data?.branch_id ??
    payload.data?.branchId;
  return id != null && id !== "" ? id : null;
}

/** True when event applies to the logged-in branch (or branch is omitted). */
export function isSocketForCurrentBranch(
  payload,
  branchId = getSessionBranchId(),
) {
  const eventBranch = socketPayloadBranchId(payload);
  if (eventBranch == null) return true;
  if (branchId == null || branchId === "") return true;
  return String(eventBranch) === String(branchId);
}

export function dispatchDashboardPoolInvalidate() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ERP_DASHBOARD_POOL_INVALIDATE_EVENT));
}

export function dispatchProductGroupPoolInvalidate() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(ERP_PRODUCT_GROUP_POOL_INVALIDATE_EVENT),
  );
}

/** Normalize tag_cancelled payload → { product_id, product_group_id, remaining_*, product_status, pool }. */
export function normalizeTagCancelledPayload(payload) {
  const cancel = payload?.cancel ?? payload?.data?.cancel ?? payload ?? {};
  const pool = cancel.pool ?? payload?.pool ?? null;
  return {
    product_id: cancel.product_id ?? cancel.productId,
    product_group_id: cancel.product_group_id ?? cancel.productGroupId,
    remaining_nwt:
      cancel.remaining_nwt ?? cancel.remainingNwt ?? cancel.nwt ?? null,
    remaining_pcs:
      cancel.remaining_pcs ?? cancel.remainingPcs ?? cancel.pcs ?? null,
    product_status: cancel.product_status ?? cancel.productStatus ?? null,
    pool,
  };
}

/** Normalize product_group_pool_updated payload → pool rows with product_group_id. */
export function normalizeProductGroupPoolUpdatedPayload(payload) {
  const pools = payload?.pools ?? payload?.data?.pools ?? [];
  if (!Array.isArray(pools)) return [];
  return pools
    .map((pool) => ({
      product_group_id: pool.product_group_id ?? pool.productGroupId,
      pool_nwt: pool.pool_nwt ?? pool.poolNwt,
      pool_pcs: pool.pool_pcs ?? pool.poolPcs,
    }))
    .filter((pool) => pool.product_group_id != null);
}
